import { home } from './home.js';
import { labels } from './labels.js';
import { msgs } from './msgs.js';
import { titles } from './titles.js';

export default {
  home,
  labels,
  msgs,
  titles,
};
